import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import product from '@/components/product'
import about from '@/components/about'
import scene from '@/components/scene'
import productPrice from '@/components/productPrice'
import "babel-polyfill"
import contents from '@/components/contents'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/scene',
      name: 'scene',
      component: scene
    },
    {
      path: '/productPrice',
      name: 'productPrice',
      component: productPrice
    },
    {
      path: '/contents',
      name: 'contents',
      component: contents
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js